import React, { useState, useEffect } from 'react';
import { useRatingScaleService, DEFAULT_RATING_SCALE } from '../api/RatingScaleService';

const RatingInput = ({ value, onChange, disabled, locked, ariaLabel, orgUnitId }) => {
  const { loadRatingScale } = useRatingScaleService(orgUnitId);
  const [ratingScale, setRatingScale] = useState(DEFAULT_RATING_SCALE);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (orgUnitId) {
      loadRatingScale().then(scale => {
        if (scale && Array.isArray(scale)) {
          setRatingScale(scale);
        } else {
          setRatingScale(DEFAULT_RATING_SCALE);
        }
        setLoading(false);
      }).catch(() => {
        setRatingScale(DEFAULT_RATING_SCALE);
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }, [orgUnitId]);

  const getRatingColor = (val) => {
    if (!ratingScale || !Array.isArray(ratingScale)) return '#6c757d';
    const rating = ratingScale.find(r => r && r.value === val);
    return rating ? rating.color : '#6c757d';
  };

  if (loading) {
    return <div style={{ minWidth: '200px' }}>Loading...</div>;
  }

  if (!ratingScale || !Array.isArray(ratingScale) || ratingScale.length === 0) {
    return <div style={{ minWidth: '200px' }}>No rating scale configured for this organisation</div>;
  }

  return (
    <div style={{ marginBottom: '8px' }}>
      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
        {ratingScale.map((rating) => (
          <button
            key={rating.value}
            type="button"
            onClick={() => !disabled && !locked && onChange(rating.value)}
            disabled={disabled || locked}
            style={{
              padding: '6px 12px',
              borderRadius: '20px',
              border: value === rating.value ? `2px solid ${rating.color}` : '1px solid #ddd',
              backgroundColor: value === rating.value ? `${rating.color}20` : '#f8f9fa',
              color: value === rating.value ? rating.color : '#666',
              fontWeight: value === rating.value ? 'bold' : 'normal',
              cursor: (disabled || locked) ? 'not-allowed' : 'pointer',
              fontSize: '0.85rem',
              transition: 'all 0.2s',
              opacity: (disabled || locked) ? 0.6 : 1
            }}
            title={rating.description}
            aria-label={ariaLabel || `Rate as ${rating.label}`}
          >
            {rating.label}
          </button>
        ))}
      </div>
      {value && ratingScale && (
        <div style={{ 
          marginTop: '4px', 
          fontSize: '0.75rem', 
          color: getRatingColor(value),
          fontStyle: 'italic'
        }}>
          {ratingScale.find(r => r && r.value === value)?.description}
        </div>
      )}
    </div>
  );
};

export default RatingInput;